export default "__VITE_ASSET__d273947b__"